import { AxiosError } from 'axios';
import { getCurrentUser, LOGIN_URI, LOGOUT_URI, signOut } from '../services/auth';

const getErrorHandler = (error): (() => void) | null => {
  const user = getCurrentUser();
  if (user) {
    switch (error.response.status) {
      case 401:
        return () => signOut();
      default:
        return null;
    }
  }
  return null;
};

export const errorInterceptor = <T>(error: AxiosError): Promise<T> => {
  if (error.response && ![LOGOUT_URI, LOGIN_URI].includes(<string>error.response.config.url)) {
    const handler = getErrorHandler(error);
    if (handler) {
      handler();
    }
  }
  return Promise.reject(error);
};
